export const RESEARCH_DATETIME_FORMAT = 'dd-MMM-yyyy HH:mm';

export const PERMISSION_ABILITIES = {
  view: 'view',
  edit: 'edit',
  delete: 'delete',
  approve: 'approve',
};

export const AUDIT_LOG_NAMES = {
  EVENT_VIEWED_BACK: 'eventViewedBack',
  EVENT_RAN_BACK: 'eventRanBack',
  EVENT_RUN: 'researchEventRun',
  EVENT_CREATED: 'ResearchEventCreated',
  EVENT_UPDATED: 'ResearchEventUpdated',
  EVENT_SIGNED: 'ResearchEventRunSigned',
  PROJECT_CREATED: 'ResearchProjectCreated',
  PROJECT_UPDATED: 'ResearchProjectUpdated',
  PROJECT_DELETED: 'ProjectDeleted',
  PIPELINE_CREATED: 'ResearchPipelineCreated',
  PIPELINE_APPROVED: 'ResearchPipelineSigned',
  ROLE_CREATED: 'ResearchRoleCreated',
  ROLE_UPDATED: 'ResearchRoleUpdated',
  ROLE_DELETED: 'ResearchRoleDeleted',
  REPOSITORY_MEMBER_INVITED: 'ResearchRepositoryMemberInvitationSent',
  REPOSITORY_MEMBER_ACTIVE: 'ResearchRepositoryMemberActive',
  REPOSITORY_MEMBER_CREATED: 'ResearchRepositoryMemberCreated',
  REPOSITORY_MEMBER_APPROVED: 'ResearchRepositoryMemberApproved',
  REPOSITORY_SITE_CREATED: 'ResearchRepositorySiteCreated',
  REPOSITORY_SITE_DELETED: 'ResearchRepositorySiteDeleted',
  REPOSITORY_SITE_UPDATED: 'ResearchRepositorySiteUpdated',
  RESULT_VIEW_CREATED: 'ResearchResultsViewCreated',
  RESULT_VIEW_UPDATED: 'ResearchResultsViewUpdated',
  RESULT_VIEW_DELETED: 'ResearchResultsViewDeleted',
  PROJECT_MEMBER_INVITED: 'ResearchProjectMemberInvitationSent',
  PROJECT_MEMBER_REJECTED: 'ResearchProjectMemberRejected',
  PROJECT_MEMBER_DELETED: 'ResearchProjectMemberDeleted',
  PROJECT_MEMBER_APPROVED: 'ResearchProjectMemberApproved',
  PROJECT_MEMBER_ACTIVATED: 'ResearchProjectMemberActive',
  PROJECT_MEMBER_REACTIVATED: 'ResearchProjectMemberActivated', // TODO: This one should be removed in BE. It triggers when activating a deactivated member, while PROJECT_MEMBER_ACTIVATED triggers on first activation (approval of the member)
  PROJECT_MEMBER_DEACTIVATED: 'ResearchProjectMemberDeactivated',
  PROJECT_MEMBER_ROLE_ASSIGNED: 'ResearchProjectMemberRoleAssigned',
  PROJECT_MEMBER_CREATED: 'ResearchProjectMemberCreated',
  SUBJECT_CREATED: 'ResearchSubjectCreated',
  SUBJECT_UPDATED: 'ResearchSubjectUpdated',
  FORM_CREATED: 'ResearchFormCreated',
  FORM_UPDATED: 'ResearchFormUpdated',
  FORM_APPROVED: 'ResearchFormApproved',
  FORM_DELETED: 'ResearchFormDeleted',
  RESULT_OVERRIDDEN: 'ResearchResultEntryDataOverrideCreated',
};

export const RESEARCH_AUDIT_LOG_NAMES = {
  EVENT_RUN: 'eventRan',
};

export const FORM_FIELD_TYPES = {
  multiselect: 'multiselect',
  number: 'number',
  slider: 'slider',
  radio: 'radio',
  text: 'text',
  date: 'date',
  boolean: 'boolean',
};

export const MEMBERS_INITIAL_FILTERS = {
  activation: null,
  siteId: null,
  status: [],
  name: null,
  role: null,
};

export const ResearchProjectMembersPageName = 'ResearchProjectMembersPage';

export const TASKLIST_ACTION_ICONS = {
  runIcon: 'fa-duotone fa-forward fa-swap-opacity',
  rerunIcon: 'fa-duotone fa-redo fa-swap-opacity',
  viewIcon: 'fa-duotone fa-binoculars',
  lockIcon: 'fa fa-lock fa-shake',
};

export const PIPELINE_ENVIRONMENTS = {
  live: 'live',
  design: 'design',
};

export const PROJECT_STATUS = {
  CLOSED: 'CLOSE',
  OPEN: 'OPEN',
};

export const EVENT_MODULE_TYPES = {
  SEGMENTATION: 'segmentation',
  UPLOAD: 'upload',
  DICOM: 'dicom',
  FORM: 'form',
  // TODO: complete the enum
};

export const SPA_ROUTES = {
  REPOSITORY_DASHBOARD: '/research/repository/{repositoryUuid}/projects',
};

export const RESEARCH_FORMS_VERSIONS = {
  ALL: 'all',
  LATEST: 'latest',
};

export const RESEARCH_REPORTS_STATUS = {
  CREATED: 'created',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  PENDING_APPROVAL: 'pending_approval',
};

export const RESEARCH_REPORTS_NUMBER_OF_QC_MEMBERS_TO_SHOW = 5;
export const RESEARCH_REPORTS_NUMBER_OF_QC_ROLES_TO_SHOW = 2;

export const RESEARCH_RESULTS_ENTRY_TYPES = {
  ENTRY: 'entry',
  STAGE: 'stage',
  MEASUREMENT: 'measurement',
};

export const RESEARCH_PREVIOUS_REPORT_STILL_PROCESSING = 'previous report still processing';

export const RESEARCH_PREVIOUS_REPORT_STILL_PROCESSING_STATUS_CODE = 'status code 422';

export const USER_NOTIFICATION_EVENTS_PAYLOAD = {
  email: 'emailChannel',
  webApp: 'webChannel',
  mobile: 'mobileChannel',
};

export const MODELS_CLASS_NAMES = {
  RESEARCH_SEGMENTATION_INSTANCE: 'App\\Models\\ResearchSegmentationInstance',
  RESEARCH_TOOL_INSTANCE: 'App\\Models\\ResearchToolInstance',
  RESEARCH_ATTACHMENT: 'App\\Models\\ResearchAttachment',
  FORM_INSTANCE: 'App\\Models\\FormInstance',
  DICOM_CASE: 'App\\Models\\DicomCase',
};

export const RESEARCH_MERGE_ERROS = {
  NOT_SAME_PATIENT: 'Series do not belong to the same patient',
};

export const RESEARCH_RESULTS_LAYOUTS = {
  TALL_AND_SKINNY: 'tall_skinny',
  SHORT_AND_FAT: 'short_fat',
};

export const RESEARCH_ELECTRONIC_SIGNATURES_ERRORS = {
  INVALID_SIGNATURE: 'Invalid electronic signature',
  GENERIC_ERROR: 'An error occurred while processing the electronic signature',
};

export const RESEARCH_PROJECT_MEMBERS_APPROVAL_ACTIONS = {
  approve: 'approve',
  reject: 'reject',
};

export const INPUT_TEXT_EVENTS_TYPES = {
  INSERT_FROM_PASTE: 'insertFromPaste',
  INSERT_FROM_DROP: 'insertFromDrop',
  INSERT_TEXT: 'insertText',
  DELETE_CONTENT_BACKWARD: 'deleteContentBackward',
  DELETE_CONTENT_FORWARD: 'deleteContentForward',
  HISTORY_UNDO: 'historyUndo',
  HISTORY_REDO: 'historyRedo',
};

export const RESEARCH_EVENT_TYPES = {
  STANDARD: 'standard',
  QUALITY_CONTROL: 'quality_control',
};

export const RESEARCH_PIPELINE_ERRORS = {
  EVENT_QC_IN_USE: 'because it is a QC event and already in use',
};

export const RESEARCH_SCREENING_REPORT_GENERATION_MODE = {
  DRAFT: 'draft',
  SUBMITTED: 'submitted',
  APPROVED: 'approved',
};

export const RESEARCH_SCREENING_MODULE_UUID_PREFIX = 'ScreeningModule-';

// TODO: remove this enum and use RESEARCH_MEMBERS_ACTIVATION_STATES
export const RESEARCH_MEMBERS_STATES = {
  ACTIVATED: 'activated',
  DEACTIVATED: 'deactivated',
};

export const RESEARCH_MEMBERS_ACTIVATION_STATUS = RESEARCH_MEMBERS_STATES;

export const RESEARCH_MEMBERS_STATUS = {
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

export const RESEARCH_MEMBERS_LOGS_SORT_OPTIONS = {
  ASC: 'asc',
  DESC: 'desc',
};

export const RESEARCH_READONLY_DELETABLE_FIELD_TYPES = [
  FORM_FIELD_TYPES.text,
  FORM_FIELD_TYPES.number,
  FORM_FIELD_TYPES.slider,
  FORM_FIELD_TYPES.radio,
  FORM_FIELD_TYPES.multiselect,
  FORM_FIELD_TYPES.date,
  FORM_FIELD_TYPES.boolean,
];

export const RESEARCH_PERMANENTLY_DELETED_INDICATOR = '%~~DELETED~~%';

export const RESEARCH_PERMANENT_DELETE_AUDIT_LOG_TYPE = {
  REPORT: 'report',
  STUDY: 'study',
  ATTACHMENT: 'attachment',
  FORM: 'form_field',
  SERIES: 'series',
};

export const RESEARCH_PERMANENTLY_DELETED_TEXT = 'Permanently Deleted';

export const RESEARCH_PERMANENT_DELETE_CONFIRMATION_TEXT = 'Permanently Delete';

export const RESEARCH_PERMANENT_DELETE_ENDPOINTS = {
  STUDY: 'repositories.projects.subjects.events.modules.studies.delete',
  ATTACHMENT: 'repositories.projects.subjects.events.modules.attachments.delete',
  SERIES: 'repositories.projects.subjects.events.modules.studies.series.delete',
  FORM: 'repositories.projects.subjects.events.form.anonymize',
  REPORT: 'repositories.projects.result.reports.anonymize',
};

export const RESEARCH_ENDPOINT_TYPE_CONFIG = {
  series: {
    getIdentifier: (resource) => resource.instanceId || resource.id,
    routes: {
      index: 'repositories.projects.dicom.series.endpoints.index',
      store: 'repositories.projects.dicom.series.endpoints.store',
      destroy: 'repositories.projects.dicom.series.endpoints.destroy',
    },
    buildRouteParams: ({ repository, project, identifier }) => ({
      repository,
      project,
      dicomImage: identifier,
    }),
  },
  attachment: {
    getIdentifier: (resource) => resource.id,
    routes: {
      index: 'repositories.projects.attachments.endpoints.index',
      store: 'repositories.projects.attachments.endpoints.store',
      destroy: 'repositories.projects.attachments.endpoints.destroy',
    },
    buildRouteParams: ({ repository, project, resource }) => ({
      repository,
      project,
      attachment: resource.uuid,
    }),
  },
};
